import React from 'react'
import { Modal } from 'react-bootstrap'
import { Typography, Box, IconButton, Button } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import './registeredClientModal.css'

export default function RegisteredClientModal({
  open,
  onClose,
  registeredClient = null,
}) {
  return (
    <Modal
      show={open}
      centered
      onHide={onClose}
      backdrop="static"
      className="registered-client-backdrop"
      dialogClassName="registered-client-dialog">
      {/* HEADER */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 3,
          pt: 2.8,
          pb: 1.8,
        }}>
        <Typography
          sx={{ fontSize: 22, fontWeight: 600, fontFamily: 'Open Sans' }}>
          Cliente registrado
        </Typography>

        <IconButton onClick={onClose}>
          <CloseIcon sx={{ color: '#1d4ed8' }} />
        </IconButton>
      </Box>

      {/* BODY */}
      <Box sx={{ px: 3, pb: 2 }}>
        <Typography sx={{ fontSize: 14, mb: 2, fontFamily: 'Open Sans' }}>
          No es posible crear este usuario ni la edición duplicada del cliente
          porque ya se encuentra registrado con este{' '}
          {registeredClient?.documentType || 'RUC'} y número de aviso
          operacional.
        </Typography>

        {/* Cliente registrado */}
        {registeredClient && (
          <Box
            sx={{
              background: '#fef2f2',
              borderRadius: '7px',
              px: 2,
              py: 1.6,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
              <PersonOutlineIcon sx={{ color: '#FF2A40' }} />
              <Typography
                sx={{
                  color: '#FF2A40',
                  fontWeight: 600,
                  fontSize: 16,
                  fontFamily: 'Open Sans',
                }}>
                {registeredClient.nombre}
              </Typography>
              <Typography
                sx={{
                  color: '#FF2A40',
                  fontWeight: 600,
                  fontSize: 16,
                  fontFamily: 'Open Sans',
                }}>
                {registeredClient.numeroAvisoOperacional}
              </Typography>
            </Box>

            <Typography
              sx={{
                color: '#FF2A40',
                fontWeight: 400,
                fontSize: 16,
                fontFamily: 'Open Sans',
              }}>
              {registeredClient.documentType || 'RUC'} {registeredClient.ruc}
            </Typography>
          </Box>
        )}
      </Box>

      {/* FOOTER */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          px: 3,
          pb: 2.8,
          pt: 0.5,
        }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            textTransform: 'none',
            fontSize: 14,
            minWidth: 160,
            height: 44,
            borderRadius: '5px',
            backgroundColor: '#003082',
            color: '#fff',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#003082',
              boxShadow: 'none',
            },
            '&:disabled': {
              backgroundColor: '#c4c4c4',
              color: '#fff',
            },
          }}>
          Cerrar
        </Button>
      </Box>
    </Modal>
  )
}
